// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WARNING: This section must be updated if _variables.ts is changed */
/* PERCENTAGE COLOURS */
section {
  background-color: #ffffff;
}
section .expanding-menu {
  width: 185px;
}

.primary-color {
  color: #078BCB;
}

.minimizePanel {
  width: 2rem;
}

.project-title {
  padding: 2.4rem 0 0.8rem 0;
}

.my-scrollable-list {
  flex: 1 1;
  overflow-y: scroll;
}

.selected:not(.parent-list-option) {
  color: #078BCB;
  background-color: #ebf5ff;
}

.bottom-button {
  padding: 1rem 4rem 1rem 4rem;
}

.span {
  width: 1rem;
}

.hover-on-item :hover {
  color: #078BCB;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.my-scrollable-list::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.my-scrollable-list {
  scrollbar-width: none; /* Firefox */
}

.border-style {
  border-right: 1px solid #078BCB;
}

.disabled {
  color: #caced5 !important;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/white-labelling/default/_variables.scss","webpack://./src/@itc-core/components/navigation-panels/route-navigation-menu/route-navigation-menu.component.scss"],"names":[],"mappings":"AAiDA,sEAAA;AAYA,uBAAA;AC3DA;EACC,yBDsBO;ACrBR;AACC;EACC,YAAA;AACF;;AAGA;EACC,cDTS;ACSV;;AAGA;EACC,WAAA;AAAD;;AAGA;EACC,0BAAA;AAAD;;AAGA;EACC,SAAA;EACA,kBAAA;AAAD;;AAGA;EACC,cD1BS;EC2BT,yBDxBoB;ACwBrB;;AAGA;EACC,4BAAA;AAAD;;AAIA;EACC,WAAA;AADD;;AAIA;EACC,cDxCS;ACuCV;;AAIA,gDAAA;AACA;EACC,aAAA;AADD;;AAIA,4CAAA;AACA;EACC,qBAAA,EAAA,YAAA;AADD;;AAIA;EACC,+BAAA;AADD;;AAIA;EACC,yBAAA;EACA,oBAAA;AADD","sourcesContent":["// Core theme colors\n$primary0: #0EABF7;\n$primary: #078BCB;\n$primary2: #067ab2;\n$primary3: #05699a;\n$selectedBackground: #ebf5ff;\n\n// Colour variables\n$black: #000000;\n$border-colour: #dee2e6;\n$card-border: #dfdfdf;\n$cardBorderGrey: #d9dee8;\n$disabled: #caced5;\n$disabledButtonColor: #7bb3d0;\n$disabled-background: #ececec;\n$form-error: #f84646;\n$highlight: #f5f5f5;\n$hoverHighlight: rgba(35, 31, 32, 0.31);\n$inactive: rgba(255, 0, 0, 0.1);\n$inactiveHighlight: rgba(255, 0, 0, 0.2);\n$kaliber-dark: #414448;\n$link: #2185d0;\n$placeholder: #aab2c0;\n$selectedButton: #002865;\n$subtitle: #a0a2a4;\n$white: #ffffff;\n$cardBorderGrey: #d9dee8;\n\n// Bootstrap Colours\n$secondary: #222222;\n$dark: #7a7a7a;\n$background-light: #efefef;\n$print-page-size: auto;\n\n$danger: #d9534f;\n$muted: #85959f;\n$text-muted: #85959f;\n$success: #61f2b6;\n$warning: #f0ad4e;\n$info: #5bc0de;\n$light: #f8f9fa;\n$light-gray: #d3d3d3;\n$background-dark: #414448;\n$disabled-background: rgba(221, 221, 221, 0.3) !default;\n\n// Common Styles\n$border: 1px solid $border-colour;\n$appComsHeight: 60px;\n\n/* WARNING: This section must be updated if _variables.ts is changed */\n$target: #fcb800;\n$declined: #d11f4b;\n$active: #f77f21;\n$quoteReady: #d299c4;\n$quoteApproved: #7c4795;\n$submitted: #662066;\n$won: #3e9937;\n$lost: #00245e;\n$live: #00b0f0;\n$completed: #a9d18e;\n\n/* PERCENTAGE COLOURS */\n$percentage-green: #15b422;\n$percentage-light-green: #a3d000;\n$percentage-yellow: #fcb000;\n$percentage-red: #ff0000;\n\n// DO NOT USE IF YOU SEE THESE BEING USED. PLEASE REMOVE\n$exportTableHeight: 530px;\n$footerHeight: 60px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n$headerHeight: 42px;\n$inputPercentWidth: 91px;\n$inputDiscountWidth: 126px;\n$exportTableHeight: 530px;\n$incExcTableHeight: 300px;\n$sidebarMenuWidth: 120px;\n$sideNavWidth: 67px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n\n// Image References\n$loginLogo: './assets';\n","@import 'variables';\n\nsection {\n\tbackground-color: $white;\n\n\t.expanding-menu {\n\t\twidth: 185px;\n\t}\n}\n\n.primary-color {\n\tcolor: $primary;\n}\n\n.minimizePanel {\n\twidth: 2rem;\n}\n\n.project-title {\n\tpadding: 2.4rem 0 0.8rem 0;\n}\n\n.my-scrollable-list {\n\tflex: 1 1;\n\toverflow-y: scroll;\n}\n\n.selected:not(.parent-list-option) {\n\tcolor: $primary;\n\tbackground-color: $selectedBackground;\n}\n\n.bottom-button {\n\tpadding: 1rem 4rem 1rem 4rem;\n}\n\n// temporary class. Will be removed when spans changed to Icons\n.span {\n\twidth: 1rem;\n}\n\n.hover-on-item :hover {\n\tcolor: $primary;\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.my-scrollable-list::-webkit-scrollbar {\n\tdisplay: none;\n}\n\n/* Hide scrollbar for IE, Edge and Firefox */\n.my-scrollable-list {\n\tscrollbar-width: none; /* Firefox */\n}\n\n.border-style {\n\tborder-right: 1px solid $primary;\n}\n\n.disabled {\n\tcolor: $disabled !important;\n\tpointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
